/**
 * Qui peut LIRE le dossier d'un autre (IBAN, NISS, carte d'identité…) — miroir de
 * DROITS_LIRE_DOSSIER dans backend/src/services/user.service.js.
 */
export const DROITS_LIRE_DOSSIER = ['users.read.all', 'users.update.all'];

// Champs du DOSSIER — miroir de CHAMPS_DOSSIER (backend/src/services/user.service.js).
export const CHAMPS_DOSSIER = [
  'address', 'iban', 'birthPlace', 'dependentsCount', 'maritalStatus', 'spouseName', 'spouseWorks',
  'idCardNumber', 'niss', 'nationality', 'gender', 'language', 'disabledWorker', 'survivorPension',
  'spouseBirthDate', 'spouseIncome', 'ciRectoPath', 'ciVersoPath',
];
